import React, { useState } from "react";
import { Link } from "react-router-dom";

import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  CssBaseline,
  Toolbar,
  Collapse,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  Group as GroupIcon,
  Inventory as InventoryIcon,
  Category as CategoryIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  AccountCircle as AccountCircleIcon,
  Healing as HealingIcon,
  DesignServices as DesignServicesIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  LocalOffer as LocalOfferIcon,
  CardGiftcard as CardGiftcardIcon,
  Redeem as RedeemIcon,
  CreditCard as CreditCardIcon,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { sideBarPages } from "../common/constant";

const drawerWidth = 240;

const SideBar = ({ mobileOpen, handleDrawerToggle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openSections, setOpenSections] = useState({
    userManagement: false,
    services: false,
  });
  const menuItems = [
    {
      name: sideBarPages.DASHBOARD,
      path: "/dashboard",
      icon: <DashboardIcon />,
    },
    {
      name: sideBarPages.USERS,
      path: "/users",
      icon: <GroupIcon />,
    },
    {
      name: sideBarPages.ORGANISATIONS,
      path: "/organisations",
      icon: <InventoryIcon />,
    },
    {
      name: sideBarPages.CATEGORIES,
      path: "/categories",
      icon: <CategoryIcon />,
    },
    {
      name: "Services",
      path: "/services",
      icon: <DesignServicesIcon />,
    },
    {
      name: sideBarPages.ADMINS,
      path: "/admins",
      icon: <AdminPanelSettingsIcon />,
    },
    {
      name: sideBarPages.PROFILE,
      path: "/profile",
      icon: <AccountCircleIcon />,
    },
    {
      name: sideBarPages.MEDICINES,
      path: "/medicines",
      icon: <HealingIcon />,
    },
    {
      name: "Generate Promo Codes",
      path: "/super-admin/generate-promo-codes",
      icon: <RedeemIcon />,
    },
    {
      name: "Get Promo Code",
      path: "/assign-promo-code",
      icon: <RedeemIcon />,
    },
  ];

  const handleToggle = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const drawer = (
    <>
      <Toolbar />
      <List>
        {/* Dashboard */}
        <ListItem>
          <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Link
                to="/dashboard"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {sideBarPages.DASHBOARD}
              </Link>
            }
          />
        </ListItem>

        {/* Organisations */}
        <ListItem>
          <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
            <InventoryIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Link
                to="/organisations"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {sideBarPages.ORGANISATIONS}
              </Link>
            }
          />
        </ListItem>

        {/* Categories */}
        <ListItem>
          <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
            <CategoryIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Link
                to="/categories"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {sideBarPages.CATEGORIES}
              </Link>
            }
          />
        </ListItem>

        {/* USER MANAGEMENT SECTION */}
        <ListItem button onClick={() => handleToggle("userManagement")}>
          <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
            <GroupIcon />
          </ListItemIcon>
          <ListItemText primary="User Management" />
          {openSections.userManagement ? (
            <ExpandLessIcon />
          ) : (
            <ExpandMoreIcon />
          )}
        </ListItem>
        <Collapse in={openSections.userManagement} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 4 }}>
            <ListItem>
              <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
                <AdminPanelSettingsIcon />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Link
                    to="/admins"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {sideBarPages.ADMINS}
                  </Link>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
                <GroupIcon />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Link
                    to="/users"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {sideBarPages.USERS}
                  </Link>
                }
              />
            </ListItem>
          </List>
        </Collapse>

        {/* SERVICES SECTION */}
        <ListItem button onClick={() => handleToggle("services")}>
          <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
            <DesignServicesIcon />
          </ListItemIcon>
          <ListItemText primary="Services" />
          {openSections.services ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </ListItem>
        <Collapse in={openSections.services} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 4 }}>
            <ListItem>
              <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
                <LocalOfferIcon />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Link
                    to="/services"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {sideBarPages.DISCOUNTS}
                  </Link>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
                <HealingIcon />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Link
                    to="/medicines"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {sideBarPages.MEDICINES}
                  </Link>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
                <CardGiftcardIcon />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Link
                    to="/assign-promo-code"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {sideBarPages.ASSIGNPROMO}
                  </Link>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
                <RedeemIcon />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Link
                    to="/super-admin/generate-promo-codes"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {sideBarPages.GENERATEPROMO}
                  </Link>
                }
              />
            </ListItem>
          </List>
        </Collapse>

        {/* Cards */}
        <ListItem>
          <ListItemIcon sx={{ color: "inherit", minWidth: "35px" }}>
            <CreditCardIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Link
                to="/cards"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {sideBarPages.CARDS}
              </Link>
            }
          />
        </ListItem>
      </List>
    </>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {isMobile ? (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              background: "linear-gradient(90deg, #20164F, #20164F)",
              color: "aliceblue",
            },
          }}
        >
          {drawer}
        </Drawer>
      ) : (
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              background: "linear-gradient(90deg, #20164F, #20164F)",
              color: "aliceblue",
            },
          }}
          variant="permanent"
          anchor="left"
        >
          {drawer}
        </Drawer>
      )}
    </Box>
  );
};

export default SideBar;
